import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {setAgreeEmailCheckbox, setProductionSheetCheckbox} from "../../actions/serverFunctions";
import Config from "../../config";
import UiIcon from "../ui/icons/uiIcon";
import {toggleHideItemsSwitcher} from "../../actions/actionFunctions";

const AgreeEmailCheckbox = (props) => {

  const {setAgreeEmailCheckbox, agreeEmailCheckbox, fabricatorData, assignQuotePopupSaveButtons, toggleHideItemsSwitcher,
    productionSheetCheckbox, setProductionSheetCheckbox} = props;

  const [changedShowPrices, setChangedShowPrices] = useState(false);

  useEffect(() => {
    if ((fabricatorData.settings.useFabricatorCostPrices || productionSheetCheckbox) && agreeEmailCheckbox) {
      setAgreeEmailCheckbox(false);
    }
  }, [fabricatorData, agreeEmailCheckbox, setAgreeEmailCheckbox, productionSheetCheckbox, setProductionSheetCheckbox]);

  const agreeEmailCheckboxVisible = (Config.isDevMode() || document.kvConfig.isBackend) && !fabricatorData.isCaesarStone
    && (assignQuotePopupSaveButtons !== "updateTax");

  if (!agreeEmailCheckboxVisible) {
     return null
  }

  const disabled = fabricatorData.settings.useFabricatorCostPrices || productionSheetCheckbox;
  const prodSheetDisabled = fabricatorData.settings.useFabricatorCostPrices;

  const agreeEmailCheckboxClick = () => {
    if (disabled || productionSheetCheckbox) {
      return false
    }
    setAgreeEmailCheckbox(!agreeEmailCheckbox);
  };

  const prodSheetCheckboxClick = () => {
    if (prodSheetDisabled) {
      return false
    }
    const newValue = !productionSheetCheckbox;
    if (newValue) {
      if (fabricatorData.hideCheckoutBreakdownCost) {
        toggleHideItemsSwitcher(); // always show prices even if they are off
        setChangedShowPrices(true); // restore prices then after toggle back
      }
    } else if (changedShowPrices) {
      toggleHideItemsSwitcher(); // return back
    }
    setProductionSheetCheckbox(newValue);
  };

  return (
    <div className="ui-popup__footer-left flex flex--wrap flex--center flex--start">
      <button className="ui-checkbox-wrapper"
              style={{marginRight: "0.5rem"}}
              onClick={agreeEmailCheckboxClick}
              title={disabled ? "Cost prices are on" : ""}>
        <div className={"ui-checkbox ui-checkbox--small" + (agreeEmailCheckbox ? " ui-checkbox--checked-svg" : "")
          + (disabled ? " ui-checkbox--disabled" : "")}>
          <div className="ui-checkbox__svg">
            <UiIcon icon="checkmark"/>
          </div>
        </div>
        <span className={"ui-checkbox__label ui-checkbox__text" + (disabled ? " ui-checkbox__label--disabled" : "")}>
          <FormattedMessage id="assignPopup.emailAgreeCheckbox"/>
        </span>
      </button>
      {fabricatorData.enableProductionSheet ? (
        <button className="ui-checkbox-wrapper nowrap" onClick={prodSheetCheckboxClick} title={prodSheetDisabled ? "Cost prices are on" : ""}>
          <div className={"ui-checkbox ui-checkbox--small" + (productionSheetCheckbox ? " ui-checkbox--checked-svg" : "")
            + (prodSheetDisabled ? " ui-checkbox--disabled" : "")}>
            <div className="ui-checkbox__svg">
              <UiIcon icon="checkmark"/>
            </div>
          </div>
          <span className={"ui-checkbox__label ui-checkbox__text" + (prodSheetDisabled ? " ui-checkbox__label--disabled" : "")}>
          <FormattedMessage id="assignPopup.productionSheetCheckbox"/>
        </span>
        </button>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {assignQuotePopupSaveButtons} = store.assignQuoteState;
  const {agreeEmailCheckbox, productionSheetCheckbox} = store.serverState;

  return {
    agreeEmailCheckbox,
    productionSheetCheckbox,
    fabricatorData: store.fabricatorState,
    assignQuotePopupSaveButtons,
  };
};

const mapDispatchToProps = {
  setAgreeEmailCheckbox,
  setProductionSheetCheckbox,
  toggleHideItemsSwitcher,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AgreeEmailCheckbox)
)
